import Store from 'store/store';
import { addClass, removeClass, accessNested, toQueryString } from 'utils/utils';

Store.on('OPEN_NAV_MENU', () => {
	Store.get().header.set({ open: true });
	addClass(document.body, 'locked');
	// commented for now as it breaks the scrolling in the region selector
	// document.body.addEventListener('touchmove', preventDefault, { passive: false });
	Store.emit('SET_HEADER_ACTION', {
		icon: 'close',
		action: () => Store.emit('CLOSE_NAV_MENU'),
		tag: 'closeNavMenu'
	});
});

const toCommaSeparated = val => val && Array.isArray(val) ? val.join(',') : null;
Store.on('TOGGLE_SHARE_OPEN', () => {
	const store = Store.get();
	const shareOpen = store.header.shareOpen;

	const onesheetExpanded = store.header.onesheetExpanded;

	if (shareOpen) {
		Store.get().header.set({ shareOpen: false });
	}

	if (!shareOpen && onesheetExpanded) {
		Store.emit('CLOSE_ALL_OVERLAYS');
		Store.get().header.set({ shareOpen: true });
	}

	if (shareOpen || onesheetExpanded) {
		return;
	}

	let path = accessNested(store, ['appData', 'pages', store.activePage, 'path']) || '/';
	let qs = {};

	if (store.showtimes && store.showtimes.show) {
		const geo = (store.client && store.client.geo) || {};
		const filters = store.showtimes.filters.selected || {};
		qs = {
			lat: geo.lat,
			lon: geo.lon,
			location: geo.city,
			country: geo.countryCode,
			date: toCommaSeparated(filters.date),
			format: toCommaSeparated(filters.format),
			time: toCommaSeparated(filters.time),
		};
	} else if (store.videos && store.videos.overlayOpen) {
		const activeVideo = store.videos.activeVideo;
		qs = { v: activeVideo && (activeVideo.youtubeId || activeVideo.key) };
	}

	let shareDetails = path + toQueryString(qs);
	Store.get().header.set({ shareOpen: true, shareDetails });
});

Store.on('CLOSE_ALL_OVERLAYS', () => {
	Store.get().header.set({
		open: false,
		shareOpen: false
	});
});

Store.on('CLOSE_NAV_MENU', () => {
	Store.get().header.set({ open: false });
	removeClass(document.body, 'locked');
	// document.body.removeEventListener('touchmove', preventDefault, { passive: false });
	Store.emit('REMOVE_HEADER_ACTIONS', 'closeNavMenu');
});

Store.on('CLOSE_ALL_OVERLAYS', () => {
	Store.emit('CLOSE_NAV_MENU');
});

Store.on('SET_HEADER_ACTION', (data) => {
	if (!data || !data.action) {
		console.error('Trying to set the header action without a function');
		return;
	}
	Store.get().header.actions.push(data);
});

Store.on('POP_HEADER_ACTION', () => {
	Store.get().header.actions.pop();
});

Store.on('REMOVE_HEADER_ACTIONS', (tag) => {
	let headerState = Store.get().header;
	let remaining = headerState.actions.filter(action => action.tag !== tag);
	headerState.set({ actions: remaining });
});

Store.on('TOGGLE_INTERSTITIAL_OPEN', open => {
	Store.get().header.set({ interstitialOpen: open });
});
